/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goals_FasterInputs */

const en_onboarding_goals_faster = /** @type {(inputs: Onboarding_Goals_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read faster`)
};

const es_onboarding_goals_faster = /** @type {(inputs: Onboarding_Goals_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer más rápido`)
};

/**
* | output |
* | --- |
* | "Read faster" |
*
* @param {Onboarding_Goals_FasterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_goals_faster = /** @type {((inputs?: Onboarding_Goals_FasterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goals_FasterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_goals_faster(inputs)
	return en_onboarding_goals_faster(inputs)
});